// extracted by mini-css-extract-plugin
export var searchHeader = "_7o-0";
export var searchHeaderDark = "_7o-1";